<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Swal from "sweetalert2";
    import Notification from "@/services/Notification";
    import modalAddNotificationTypesSetup from "@/components/modals/notification/modalAddNotificationTypesSetup.vue";

    export default {
        components: {
            Layout,
            PageHeader,
            modalAddNotificationTypesSetup
        },
        page: {
            title: "Notifications Type Setup",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                error: null,
                tableData: [],
                tableDataTournament: [],
                title: "Notifications Type Setup",
                items: [
                    {
                        text: "Notifications",
                    },
                    {
                        text: "Notifications Type Setup",
                        active: true,
                    },
                ],
                filterInput: {},
                isBusy: false,
                totalRows: 0,
                totalRowsTournament: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                access_object: localStorage.getItem("access_objects"),
                sortBy: "valid_from",
                sortDesc: true,
                dealData: [],
                tenantData: [],
                notificationData: [],
                fields: [
                    {
                        key: "expand",
                        label: "",
                        tdClass: "text-center",
                    },
                    {
                        key: "type_code",
                        label: "Type Code",
                    },
                    {
                      key:"type_name",
                      label: "Type Name",
                    },
                    {
                      key: "fcm_type",
                       label: "FCM Type",
                    },
                    {
                        key: "localization_key_title",
                        label: "Localization Key Title",
                    },
                    {
                        key: "localization_key_desc",
                        label: "Localization Key Description",
                    },
                    {
                        key: "system",
                        label: "System",
                    },
                    {
                        key: "action",
                        label: "Action",
                    }
                ],
                subCategoryFields: [
                    {
                        key: "type_code",
                        label: "Type Code",
                    },
                    {
                      key:"type_name",
                      label: "Type Name",
                    },
                    {
                      key: "parent",
                      label: "Parent",
                    },
                    {
                      key: "fcm_type",
                       label: "FCM Type",
                    },
                    {
                        key: "localization_key_title",
                        label: "Localization Key Title",
                    },
                    {
                        key: "localization_key_desc",
                        label: "Localization Key Description",
                    },
                    {
                        key: "system",
                        label: "System",
                    },
                    {
                        key: "action",
                        label: "Action",
                    }
                ],
                statusOptions: [],
                isBusyAll: false,
                totalRowsAll: 0,
                currentPageAll: 1,
                perPageAll: 10,
                pageOptionsAll: [10, 25, 50, 100],
                filterAll: null,
                filterOnAll: [],
                typeNew: [],
                filterData: false,
                verifyInput: "",
                loading: false,
            };
        },

        async created() {
            await this.getNotificationTypesSetup();

        },
        computed: {

            objToArray(){
              return this.access_object.split(',');
            },
        },
        methods: {

          onToggleDetails(data){
            data.toggleDetails();
          },

          rowClass(item, type){
            return type === "row" ? "notif-row" : null;
          },

          async deleteNotificationType(type_code){
            Swal.fire({
              title:"Delete Notification Type?",
              text:"This Notification Type will be deleted!",
              icon:"warning",
              showCancelButton:true,
              confirmButtonColor:"#34c38f",
              cancelButtonColor:"#f46a6a",
              confirmButtonText:"Delete"
            }).then(async (result)=>{
              if(result.isConfirmed === true){
                try {
                  await Notification.deleteNotificationTypeSetup(type_code);
                  Swal.fire("Success!", "Notification Type is successfully deleted!", "success");
                  await this.getNotificationTypesSetup();
                }catch (error) {
                  this.error = error.response && error.response.data && error.response.data.error
                      ? error.response.data.error
                      : "An error occurred while removing the Notification Type.";
                  Swal.fire("Error", this.error, "error");
                }

              }
            })
          },

            async getNotificationTypesSetup() {
                try {
                    this.typeNew = [];
                    this.isBusy = true;

                    const response = await Notification.getNotificationTypesSetup();
                    this.tableData = response.data.data || [];
                    this.totalRows = this.tableData.length;
                } catch (error) {
                    this.isBusy = false;
                    this.error = error.response?.data?.error || "";
                    this.tableData = [];
                    this.totalRows = 0;
                    this.typeNew = [];
                    this.filterData = false;
                } finally {
                    this.isBusy = false;
                }
            },
            callModalEditTeamDeal(data) {
                this.$bvModal.show("edit_automated_notification");
                this.notificationData = data
            },
            callModalAddNotificationTypesSetup() {
              this.$bvModal.show("add_notification_type");
            },
            callModalViewAttributes(data) {
              this.$bvModal.show("view_notifications_attributes");
              this.notificationData = data
            },


        },
        middleware: "authentication",
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" :fields="fields"/>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2">
                                <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light"
                                   @click="callModalAddNotificationTypesSetup">
                                    <i class="mdi mdi-plus me-2"></i>Create Notification Type
                                </a>
                            </div>
                            <div class="col-sm-12 col-md-2">
                                <a href="javascript:void(0);" class="btn btn-primary waves-effect waves-light"
                                   @click="getNotificationTypesSetup">
                                    <i class="mdi mdi-refresh me-2"></i>Refresh
                                </a>
                            </div>
                        </div>

                        <div class="row mt-4 mb-4">
                            <div class="col d-inline-flex align-items-center">
                                <h4 class="card-title m-0">Total Notification Types: {{ totalRows }}</h4>
                            </div>
                        </div>
                        <div class="row mt-4" v-show="filterData">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="deals-table_filter" class="dataTables_filter text-md-end">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <b-table
                                ref="notificationTypesTable"
                                :busy="isBusy"
                                table-class="table table-centered datatable table-card-list"
                                thead-tr-class="bg-transparent"
                                :tbody-tr-class="rowClass"
                                :items="tableData"
                                :fields="fields"
                                responsive="sm"
                                show-empty
                                empty-text="No Data Found"
                        >
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:cell(expand)="data">
                                <a
                                    v-if="data.item.sub_categories && data.item.sub_categories.length"
                                    href="javascript:void(0);"
                                    class="text-body d-inline-flex align-items-center"
                                    @click="onToggleDetails(data)"
                                >
                                    <i class="uil" :class="data.detailsShowing ? 'uil-angle-down' : 'uil-angle-right'"></i>
                                    <span class="badge bg-light text-dark ms-1">{{ data.item.sub_categories.length }}</span>
                                </a>
                            </template>

                            <template v-slot:cell(system)="data">
                                <span>{{ data.item.system === 'Y' ? 'Yes' : 'No' }}</span>
                            </template>

                            <template v-slot:cell(action)="data">
                                <ul class="list-inline mb-0">
                                    <li class="list-inline-item">
                                        <a v-if="!Number(data.item.notifications_count)"  href="javascript:void(0);" class="px-2 text-primary"  title="Delete Notification Type" @click="deleteNotificationType(data.item.type_code)">
                                            <i class="uil uil-trash-alt font-size-18"></i>
                                        </a>
                                        <span v-else class="px-2 text-primary" title="This notification type is used somewhere.">
                                          <i class="uil uil-trash-alt font-size-18" style="color: #e0e0e0; cursor: pointer"></i>
                                        </span>
                                    </li>
                                </ul>
                            </template>

                            <template v-slot:row-details="data">
                                <div class="sub-categories-table">
                                    <b-table
                                            table-class="table table-centered table-sm mb-0"
                                            thead-tr-class="bg-transparent"
                                            :items="data.item.sub_categories"
                                            :fields="subCategoryFields"
                                            responsive="sm"
                                            show-empty
                                            empty-text="No sub categories"
                                    >
                                        <template v-slot:cell(system)="subData">
                                            <span>{{ subData.item.system === 'Y' ? 'Yes' : 'No' }}</span>
                                        </template>

                                        <template v-slot:cell(action)="subData">
                                            <ul class="list-inline mb-0">
                                                <li class="list-inline-item">
                                                    <a v-if="!Number(subData.item.notifications_count)" href="javascript:void(0);" class="px-2 text-primary" title="Delete Notification Type" @click="deleteNotificationType(subData.item.type_code)">
                                                        <i class="uil uil-trash-alt font-size-18"></i>
                                                    </a>
                                                    <span v-else class="px-2 text-primary" title="This notification type is used somewhere.">
                                                      <i class="uil uil-trash-alt font-size-18" style="color: #e0e0e0; cursor: pointer"></i>
                                                    </span>
                                                </li>
                                            </ul>
                                        </template>
                                    </b-table>
                                </div>
                            </template>
                        </b-table>

                        <div class="row" v-show="filterData">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
      <modalAddNotificationTypesSetup @refreshScreen="getNotificationTypesSetup"></modalAddNotificationTypesSetup>
    </Layout>
</template>

<style scoped>
.sub-categories-table {
  background-color: #f7f8fb;
  border-radius: 6px;
  padding: 8px 12px;
}

.table-card-list tbody tr:hover {
  background-color: #f9f9f9;
  transition: background-color 0.2s ease;
}
</style>
